import "./bootstrap"
import "../css/app.css"

// Import modules...
import {createApp, h} from "vue";
import {createInertiaApp, router} from "@inertiajs/vue3";
import axios, {AxiosResponse} from "axios";
import { createPinia } from 'pinia'
import I18n from "@/Libs/I18n"
import JsonViewer from 'vue-json-viewer'
import { Chart, LineController, Filler, TimeScale, LinearScale, PointElement, LineElement, Tooltip } from 'chart.js';
import 'chartjs-adapter-luxon';
import * as Sentry from "@sentry/vue";
import {pushGtmEvents} from "@/Libs/utils";
import route from "ziggy-js";

Chart.register(LineController, Filler, TimeScale, LinearScale, PointElement, LineElement, Tooltip);

const el = document.getElementById('app');

function resolvePageComponent(name: string, pages: Record<string, any>) {
    const path = `./Pages/${name}.vue`
    if (pages.hasOwnProperty(path)) {
        return typeof pages[path] === 'function'
            ? pages[path]()
            : pages[path]
    }

    throw new Error(`Page not found: ${name}`)
}

const pinia = createPinia()

createInertiaApp({
    resolve: (name) => resolvePageComponent(name, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const vueApp = createApp({ render: () => h(App, props) })
            .mixin({methods: {route}})
            .use(I18n)
            .use(pinia)
            .use(JsonViewer)
            .use(plugin)

        // Init Sentry with the app instance *before* mounting, so Sentry can
        // install Vue's errorHandler. Passing the return value of .mount() here
        // hands Sentry a component proxy (no `.config`), which throws in
        // @sentry/vue and leaves render errors uncaught -> white page.
        if (import.meta.env.PROD) {
            Sentry.init({
                app: vueApp,
                dsn: "https://71550642f0744d2aaf58a5a033da68e2@o1008615.ingest.sentry.io/5972593",
                integrations: [
                    Sentry.browserTracingIntegration(),
                ],
                tracesSampleRate: 0.2,
            });
        }

        vueApp.mount(el)
    },
    progress: {
        color: '#4B5563',
    },
})

router.on('success', (event) => {
    const pageProps = event.detail?.page?.props;

    if (!pageProps) return;

    pushGtmEvents(pageProps?.jetstream?.flash?.gtm_events || null)

    if (!!pageProps?.locale) {
        I18n.global.locale.value = pageProps.locale.replace('_', '-')
    }
})
